export default "__VITE_ASSET__BVTaj9eS__"